import {AppConstants} from './AppConstants';

export const Utils = {
    getStatusIcon : (status) => {
        if (status === AppConstants.REQUEST_STATUS_INITIATED) return '📅';
        if (status === AppConstants.REQUEST_STATUS_COMPLETED) return '✓';
        if (status === AppConstants.REQUEST_STATUS_EXPIRED) return '✗';
        return '';
    },
    formatDateTime : (dateString) => {
        if (!dateString || dateString === AppConstants.NULL_DATE_STR) return '-';
        const date = new Date(dateString);
        if(date <= new Date("1970-01-01T00:00:00")) return "-";
        return date.toLocaleString('en-US', {
            timeZone: 'America/Los_Angeles',
            month: '2-digit',
            day: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    },

    getMinDateTime : () => {
        const now = new Date();
        const minTime = new Date(now.getTime() + 60 * 60 * 1000);
        return minTime.toISOString().slice(0, 16);
    },

    isOnIOSAndNotRunningAsHomeApp : ()=>{
        const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
        const asApp = (window.navigator.standalone === true);
        return (isIOS && !asApp);
    }
};